import { Outlet } from 'react-router';

import Map from '@/components/map/Map';
import { TargetSelectorProvider } from '@/contexts/TargetSelectorContext';
import { AppErrorBoundary } from '@/shared/ui/app-error-boundary/AppErrorBoundary';

export function TrackingLayout() {
  return (
    <TargetSelectorProvider>
      <Outlet />
      <AppErrorBoundary boundaryId="tracking-map">
        <Map />
      </AppErrorBoundary>
    </TargetSelectorProvider>
  );
}
